import angular from 'angular';
import MenuDirective from './menu.directive';
import MenuItemModule from './menu-item/menu-item';

let MenuModule = angular.module('home.menu', [
  MenuItemModule.name
])
  .directive('menu', MenuDirective);

export default MenuModule;



// WEBPACK FOOTER //
// ./www/components/home/menu/menu.js